<template>
  <v-dialog
    v-model="dialog"
    :max-width="maxWidth"
  >
    <template #activator="{ on, attrs }">
      <ActivatorButton
        v-if="buttonTitle"
        :parent-attrs="attrs"
        :parent-on="on"
        :icon-or-title="buttonTitle"
        :tooltip-text="title"
        :disabled="disabled"
        :style="{ display: visible ? 'flex' : 'none' }"
        @activate="onButtonActivate"
      />
    </template>

    <v-form ref="form">
      <v-card>
        <v-card-title>Change password</v-card-title>

        <v-card-text>
          <v-container>
            <v-row
              v-if="!isAdmin"
              dense
            >
              <v-col>
                <v-text-field
                  v-model="oldPassword"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="oldPasswordRules"
                  :type="show ? 'text' : 'password'"
                  label="Old password"
                  @click:append="show = !show"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-text-field
                  v-model="password"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="passwordRules"
                  :type="show ? 'text' : 'password'"
                  counter
                  hint="At least 6 characters"
                  label="Password"
                  @click:append="show = !show"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-text-field
                  v-model="password2"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="password2Rules"
                  :type="show ? 'text' : 'password'"
                  counter
                  hint="At least 6 characters"
                  label="Repeat password"
                  @click:append="show = !show"
                />
              </v-col>
            </v-row>
          </v-container>

          <div
            v-if="message"
            style="color: red"
          >
            {{ message }}
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="onUpdate"
            aria-label="Update button"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import md5 from 'md5'
import DialogBase from '@/components/dialogs/DialogBase.vue'
import { AUTH_URL, getErrorMessage } from '@/main'
import { mapGetters } from 'vuex'
import ActivatorButton from '@/components/ActivatorButton.vue'

export default {
  components: { ActivatorButton },
  mixins: [DialogBase],

  props: {
    item: {
      type: [Object, null],
      default: null,
    },
  },

  data: () => ({
    oldPassword: null,
    password: null,
    password2: null,
    show: false,
    rules: {
      required: (value) => !!value || 'Required',
      min: (v) => v != null && (v.length >= 6 || 'Min 6 characters'),
    },
  }),

  computed: {
    ...mapGetters(['isAdmin']),
    oldPasswordRules() {
      return [this.rules.required]
    },
    passwordRules() {
      return [this.rules.required, this.rules.min]
    },
    password2Rules() {
      return [this.rules.required, this.rules.min, this.passwordsMatchRule]
    },
    passwordsMatchRule() {
      return this.password === this.password2 || 'Passwords do not match'
    },
  },

  methods: {
    onUpdate() {
      if (this.$refs.form.validate()) {
        this.$axios
          .patch(`${AUTH_URL}/users/${this.item.id}/password`, {
            oldPasswordHash: this.isAdmin ? null : md5(this.oldPassword || ''),
            passwordHash: md5(this.password),
          })
          .then(() => {
            this.close()
          })
          .catch((error) => (this.message = getErrorMessage(error)))
      }
    },
  },
}
</script>
